// extracted by mini-css-extract-plugin
export default {"expenseItem":"IncomeItem_expenseItem__73XTc","badge":"IncomeItem_badge__K4Af6"};